/**
 * Thin, defensive localStorage wrapper shared by metaProgress.ts (permanent
 * unlocks/stats) and cardGame.ts (the resumable in-progress run). WebView
 * storage can throw (private-mode-like restrictions) or simply be missing —
 * every call is guarded so a storage failure degrades to "nothing persisted
 * this session" rather than crashing the game.
 */
export function readJson<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Best-effort — a save failure just means this change won't survive a
    // reload; the in-memory game state is unaffected either way.
  }
}

export function removeKey(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
